import React, { FunctionComponent, PropsWithChildren } from 'react'
import { useCheckoutState, useDisplayProcessingModal } from '../../state'
import { CheckoutStatus } from '../../model'

type StatusCondition = (status: CheckoutStatus) => boolean

interface CheckoutStatusGuardProps extends PropsWithChildren {
  condition: StatusCondition
  tearDownOnConfirm?: boolean
}

export const CheckoutStatusGuard: FunctionComponent<CheckoutStatusGuardProps> = ({ condition, children, tearDownOnConfirm = true }) => {
  const { status } = useCheckoutState()
  const displayProcessingModal = useDisplayProcessingModal()

  if (tearDownOnConfirm && status >= CheckoutStatus.Confirmed && displayProcessingModal) {
    return null
  }

  if (!condition(status)) {
    return null
  }

  return <>{children}</>
}

interface PreconfiguredGuardProps extends PropsWithChildren {
  tearDownOnConfirm?: boolean
}

export const NoErrorStatusGuard: FunctionComponent<PreconfiguredGuardProps> = ({ children, tearDownOnConfirm }) => (
  <CheckoutStatusGuard condition={(status) => status !== CheckoutStatus.Error} tearDownOnConfirm={tearDownOnConfirm}>
    {children}
  </CheckoutStatusGuard>
)

export const StartedStatusGuard: FunctionComponent<PreconfiguredGuardProps> = ({ children, tearDownOnConfirm }) => (
  <CheckoutStatusGuard condition={(status) => status >= CheckoutStatus.Started} tearDownOnConfirm={tearDownOnConfirm}>
    {children}
  </CheckoutStatusGuard>
)
